<template>
    <section class="internal-page privacy-page">
        <internal-page-header
            eyebrow="Transparência"
            title="Política de privacidade"
            description="Conheça as informações sobre o tratamento de dados pessoais pela PB&B."
        />
        <v-container class="pa-0 mx-auto">
            <v-row justify="center">
                <v-col cols="11" lg="10">
                    <v-row class="mb-10 px-2">
                        <h2 class="text-h5 text-lg-h4 font-weight-black primary--text mb-5">
                            Quem Somos
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A
                                <strong
                                    >Paoli Balbino & Balbino Sociedade de Advogados e Paoli Balbino
                                    Administração Judicial</strong
                                >, doravante denominadas (<strong>“PBB”</strong>)
                                /(<strong>“AJ”</strong>), inscritas no CNPJ sob os números
                                22.714.890/0001-36 e 31.841.449/0001-06 respectivamente, com
                                endereço na Avenida Brasil, nº 1666, 13º andar, Bairro Funcionários,
                                Belo Horizonte/MG, CEP 30140-004, é um escritório de advocacia e
                                administração judicial com atuação especializada especialmente em
                                insolvência civil, Direito Recuperacional e Falimentar, exercendo o
                                papel de agente econômico fundamental à redução da assimetria entre
                                devedor e credor, garantindo a higidez do sistema de insolvência no
                                Brasil, tendo como fundamento a excelência, o estrito cumprimento
                                das normas legais, a transparência e a eficiência.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h5 text-lg-h4 font-weight-black primary--text mb-5">
                            Do Aviso de Privacidade
                        </h2>
                        <div>
                            <p class="text-h6 text-lg-justify font-weight-regular">
                                Este Aviso é pautado na <strong>boa-fé</strong>, na
                                <strong>ética</strong> e nos princípios da
                                <strong>
                                    finalidade, adequação, necessidade, livre acesso, qualidade dos
                                    dados, transparência, segurança, prevenção, não discriminação,
                                    responsabilização e prestação de Contas</strong
                                >, nos termos do art. 6º, da Lei 13.709/2018.
                            </p>

                            <p class="text-h6 text-lg-justify font-weight-regular">
                                Para fins de interpretação dos princípios contemplados neste Aviso
                                de Privacidade, entende-se como:
                            </p>

                            <ol class="text-h6 text-lg-justify font-weight-regular pa-2 px-lg-10">
                                <li>
                                    <strong> Boa-fé: </strong> agir com lealdade e retidão por meio
                                    da troca de informações claras e objetivas, em Juízo ou fora
                                    dele, extrajudicialmente, especialmente em respostas a
                                    solicitações ou questionamentos de credores e/ou terceiros
                                    interessados.
                                </li>
                                <li>
                                    <strong>Ética:</strong>
                                    atuação pautada em padrões e valores morais tanto no cumprimento
                                    do encargo, quanto no tratamento de dados pessoais,
                                    confidenciais e sigilosos, com o cuidado e responsabilidade dos
                                    quais se espera ou entende-se esperar seus titulares.
                                </li>
                                <li>
                                    <strong>Finalidade: </strong>
                                    realização do tratamento para propósitos legítimos, específicos,
                                    explícitos e informados ao titular, sem possibilidade de
                                    tratamento posterior de forma incompatível com as finalidades
                                    das quais são coletados, salvo se houver alteração na finalidade
                                    da coleta.
                                </li>
                                <li>
                                    <strong>Adequação: </strong>
                                    compatibilidade do tratamento com as finalidades informadas ao
                                    titular, de acordo com o contexto do tratamento.
                                </li>
                                <li>
                                    <strong>Necessidade:</strong> limitação do tratamento ao mínimo
                                    necessário para a realização de suas finalidades, com
                                    abrangência dos dados pertinentes, proporcionais e não
                                    excessivos em relação às finalidades do tratamento de dados.
                                </li>
                                <li>
                                    <strong>Livre Acesso: </strong> garantia, aos titulares, de
                                    consulta facilitada sempre que possível e de forma gratuita
                                    sobre a utilização e a duração do tratamento, bem como sobre a
                                    integralidade de seus dados pessoais.
                                </li>
                                <li>
                                    <strong>Qualidade dos Dados:</strong> garantia, aos titulares,
                                    da exatidão, clareza, relevância e atualização dos dados, de
                                    acordo com a necessidade e para o cumprimento da finalidade de
                                    seu tratamento.
                                </li>
                                <li>
                                    <strong>Transparência: </strong> garantia, aos titulares, de
                                    informações claras, precisas e facilmente acessíveis sobre a
                                    realização do tratamento e os respectivos agentes de tratamento,
                                    observados os segredos comercial e industrial ou ainda o sigilo
                                    judicial.
                                </li>
                                <li>
                                    <strong>Segurança: </strong> utilização de medidas técnicas e
                                    administrativas aptas a proteger os dados pessoais de acessos
                                    não autorizados e de situações acidentais ou ilícitas de
                                    destruição, perda, alteração, comunicação ou difusão.
                                </li>
                                <li>
                                    <strong>Prevenção: </strong> adoção de medidas para prevenir a
                                    ocorrência de danos em virtude do tratamento de dados pessoais.
                                </li>
                                <li>
                                    <strong>Não Discriminação: </strong>
                                    impossibilidade de realização do tratamento para fins
                                    discriminatórios ilícitos ou abusivos.
                                </li>
                                <li>
                                    <strong>Responsabilização e Prestação de Contas: </strong>
                                    demonstração, pelo agente, da adoção de medidas eficazes e
                                    capazes de comprovar a observância e o cumprimento das normas de
                                    proteção de dados pessoais e, inclusive, da eficácia dessas
                                    medidas.
                                </li>
                            </ol>
                        </div>

                        <div>
                            <p class="text-h6 text-lg-justify font-weight-regular">
                                Este Aviso define os detalhes essenciais relativos aos dados
                                pessoais compartilhados e/ou tratados pela PBB.
                            </p>
                            <p class="text-h6 text-lg-justify font-weight-regular">
                                Qualquer alteração relevante na forma da qual são coletados ou
                                processados os dados pessoais dos titulares, (credores e/ou terceiro
                                interessado), serão fornecidos pela
                                <strong>PBB</strong> , por meio de “Avisos Adicionais” ou “Aditivo”
                                ao presente “Aviso de Privacidade”, com as informações necessárias
                                para o conhecimento do titular, em prol da transparência no
                                tratamento de seus dados, o que será divulgado por meio do site
                                www.pbbadvogados.com.br
                            </p>
                            <p class="text-h6 text-lg-justify font-weight-regular">
                                A <strong>PBB</strong> possui, com o presente “Aviso”, o objetivo de
                                garantir que o titular compreenda as razões pelas quais são
                                coletados e utilizados os seus dados pessoais, informando a
                                necessidade e a forma que a coleta é realizada, assim como,
                                explicando de forma clara e transparente, os direitos e opções de
                                escolha referentes ao tratamento dos seus dados, quando possível,
                                preservando sempre a privacidade e a segurança do titular.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h5 text-lg-h4 font-weight-black primary--text mb-5">
                            Outras definições e regras de interpretação
                        </h2>
                        <div>
                            <ul class="text-h6 text-lg-justify font-weight-regular px-lg-10">
                                <li>
                                    <strong>I – Dado Pessoal: </strong>
                                    informação relacionada a pessoa natural identificada ou
                                    identificável;
                                </li>
                                <li>
                                    <strong>II – Dado Pessoal Sensível: </strong>
                                    dado pessoal sobre origem racial ou étnica, convicção religiosa,
                                    opinião política, filiação a sindicato ou a organização de
                                    caráter religioso, filosófico ou político, dado referente à
                                    saúde ou à vida sexual, dado genético ou biométrico, quando
                                    vinculado a uma pessoa natural;
                                </li>
                                <li>
                                    <strong>III – Dado Anonimizado: </strong>
                                    dado relativo a titular que não possa ser identificado,
                                    considerando a utilização de meios técnicos razoáveis e
                                    disponíveis na ocasião de seu tratamento;
                                </li>
                                <li>
                                    <strong>IV – Banco de Dados:</strong>
                                    conjunto estruturado de dados pessoais, estabelecido em um ou em
                                    vários locais, em suporte eletrônico ou físico;
                                </li>
                                <li>
                                    <strong>V – Titular:</strong> pessoa natural a quem se referem
                                    os dados pessoais que são objeto de tratamento;
                                </li>
                                <li>
                                    <strong>VI – Controlador: </strong> pessoa natural ou jurídica,
                                    de direito público ou privado, a quem competem as decisões
                                    referentes ao tratamento de dados pessoais;
                                </li>
                                <li>
                                    <strong>VII – Operador: </strong> pessoa natural ou jurídica, de
                                    direito público ou privado, que realiza o tratamento de dados
                                    pessoais em nome do controlador;
                                </li>
                                <li>
                                    <strong>VIII – Encarregado: </strong> pessoa indicada pelo
                                    controlador e operador para atuar como canal de comunicação
                                    entre o controlador, os titulares dos dados e a Autoridade
                                    Nacional de Proteção de Dados (ANPD);
                                </li>
                                <li>
                                    <strong>IX – Agentes de Tratamento: </strong>
                                    o controlador e o operador;
                                </li>
                                <li>
                                    <strong>X – Tratamento: </strong> toda operação realizada com
                                    dados pessoais, como as que se referem a coleta, produção,
                                    recepção, classificação, utilização, acesso, reprodução,
                                    transmissão, distribuição, processamento, arquivamento,
                                    armazenamento, eliminação, avaliação ou controle da informação,
                                    modificação, comunicação, transferência, difusão ou extração;
                                </li>
                                <li>
                                    <strong>XI – Anonimização: </strong>
                                    utilização de meios técnicos razoáveis e disponíveis no momento
                                    do tratamento, por meio dos quais um dado perde a possibilidade
                                    de associação, direta ou indireta, a um indivíduo;
                                </li>
                                <li>
                                    <strong>XII – Consentimento: </strong>
                                    manifestação livre, informada e inequívoca pela qual o titular
                                    concorda com o tratamento de seus dados pessoais para uma
                                    finalidade determinada;
                                </li>
                                <li>
                                    <strong>XIII – Bloqueio: </strong>suspensão temporária de
                                    qualquer operação de tratamento, mediante guarda do dado pessoal
                                    ou do banco de dados;
                                </li>
                                <li>
                                    <strong>XIV – Eliminação: </strong> exclusão de dado ou de
                                    conjunto de dados armazenados em banco de dados,
                                    independentemente do procedimento empregado;
                                </li>
                                <li>
                                    <strong>XV – Transferência Internacional de Dados: </strong>
                                    transferência de dados pessoais para país estrangeiro ou
                                    organismo internacional do qual o país seja membro;
                                </li>
                                <li>
                                    <strong>XVI – Uso Compartilhado de Dados: </strong>
                                    comunicação, difusão, transferência internacional, interconexão
                                    de dados pessoais ou tratamento compartilhado de bancos de dados
                                    pessoais por órgãos e entidades públicos no cumprimento de suas
                                    competências legais, ou entre esses e entes privados,
                                    reciprocamente, com autorização específica, para uma ou mais
                                    modalidades de tratamento permitidas por esses entes públicos,
                                    ou entre entes privados;
                                </li>
                                <li>
                                    <strong>XVIII – Órgão de Pesquisa: </strong>
                                    órgão ou entidade da administração pública direta ou indireta ou
                                    pessoa jurídica de direito privado sem fins lucrativos
                                    legalmente constituída sob as leis brasileiras, com sede e foro
                                    no País, que inclua em sua missão institucional ou em seu
                                    objetivo social ou estatutário a pesquisa básica ou aplicada de
                                    caráter histórico, científico, tecnológico ou estatístico;
                                </li>
                                <li>
                                    <strong>XIX – Autoridade Nacional: </strong>
                                    órgão da administração pública responsável por zelar,
                                    implementar e fiscalizar o cumprimento da Lei em todo o
                                    território nacional.
                                </li>
                            </ul>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h5 text-lg-h4 font-weight-black primary--text mb-5">
                            Da Coleta de Dados Pessoais e Legislações Observadas
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A <strong>PBB </strong> coleta dados pessoais de acordo com este
                                Aviso de Privacidade e em conformidade com a legislação aplicável
                                sobre segurança da informação, privacidade e proteção de dados,
                                inclusive, (sempre e quando aplicáveis), a
                                <strong>Constituição Federal</strong> , o
                                <strong>Código de Defesa do Consumidor</strong> , o
                                <strong>Código Civil</strong> , a
                                <strong>
                                    Lei 11.101/2005,Lei 14.112/2020e Decreto-Lei 7661/1945
                                    (“LFR”)</strong
                                >, o Marco Civil da Internet (
                                <strong>Lei Federal 12.965/2014</strong> ), seu decreto
                                regulamentador ( <strong> Decreto 8.771/2016</strong>), a Lei Geral
                                de Proteção de Dados Pessoais (<strong>
                                    Federal 13.709/2018
                                </strong>
                                Lei ), ( <strong>“LGPD”</strong> ), as Instruções Normativas e
                                Regras estabelecidas pela <strong>ANPD</strong> , e demais normas
                                setoriais ou gerais correlatas.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h5 text-lg-h4 font-weight-black primary--text mb-5">
                            Informações que Coletamos
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                Para facilitar o acesso às informações processuais especialmente
                                referente às demandas Recuperacionais e Falimentares de sua atuação,
                                a
                                <strong>PBB</strong> criou o site www.pbbadvogados.com.br com uma
                                seção dedicada a cada processo em que atua na qualidade de Auxiliar
                                do Juízo.
                                <br />
                                <br />
                                Além disso, o site é um canal de acesso facilitado para credores e
                                terceiros interessados, possibilitando o envio de mensagens à
                                <strong>PBB</strong>
                                diretamente por esta via, para realizar questionamentos e sanar
                                dúvidas, constante na aba
                                <strong>“Contato”</strong> .Para isso, os dados informados pelo
                                usuário são apenas o <strong> e-mail</strong> do titular e seu
                                <strong>nome</strong> , com a
                                <strong>
                                    <u> finalidade de retorno às mensagens. </u>
                                </strong>
                                <br />
                                <br />
                                Nesta “aba” <strong>“Contato” </strong> constante no site, há também
                                o endereço físico da <strong>PBB</strong>, sendo, Avenida Brasil, nº
                                1666, 13º andar, Bairro Funcionários, CEP 30140-004, endereço
                                eletrônico contato@pbbadvogados.com.br e telefone (31) 3656-1514,
                                para que os interessados tenham outras opções para contatar a
                                <strong>PBB</strong>, a sua escolha.
                                <br />
                                <br />
                                Na Fase Administrativa dos processos de Recuperação Judicial e
                                Falência, os credores e/ou terceiros interessados podem enviar à
                                <strong>PBB</strong> por meio do habilitacoes@pbbadvogados.com.br ou
                                pelo meio físico, na sede do <strong> e-mail</strong> escritório,
                                <u>
                                    localizado na Avenida Brasil, nº 1666, 13º andar, Bairro
                                    Funcionários, CEP 30140-004</u
                                >, todas as informações e documentos necessários para habilitação de
                                seu crédito extrajudicialmente, nos termos do § 1º, do art. 7º da
                                Lei 11.101/2005.
                                <br />
                                <br />
                                Em se tratando de pessoa natural, há o envio de documentos com
                                <strong>dados pessoais</strong> , podendo ainda, conter documentos
                                com <strong>dados pessoais sensíveis</strong> , nos termos da LGPD.
                                Outra forma de obtenção de dados pessoais é quando há o envio de
                                documentos pela Recuperanda e/ou Falida à Administradora Judicial
                                (<strong>PBB</strong>) e/ou quando da lacração da empresa em casos
                                de Falência, podendo haver informações de diversas natureza e tipos
                                de titulares de dados.
                                <br />
                                <br />
                                Todos os documentos são analisados pela Administradora
                                Judicial/Auxiliar do Juízo (<strong>PBB</strong>), com a finalidade
                                de identificar o credor, a relação jurídica oriunda do direito
                                pretendido, a constatação da existência do crédito e sua natureza,
                                além da análise dos documentos fiscais e contábeis da sociedade em
                                estrito cumprimento de sua função, nos termos da Lei 11.101/2005.
                                <br />
                                <br />
                                A <strong>PBB</strong> se limita a realizar o tratamento apenas dos
                                dados pessoais e/ou pessoais sensíveis, necessários para análise do
                                crédito do titular ou para apresentação em Juízo em ações acessórias
                                dos processos de insolvência, quando é o caso, em cumprimento do seu
                                dever legal e em observância aos princípios e legislações setoriais
                                pertinentes.
                            </p>

                            <ul class="font-weight-black">
                                <li class="text-lg-justify text-h6">
                                    Dado Pessoal e Dado Pessoal Sensível Coletado em Razão da
                                    Audiência prevista no artigo 104, da Lei 11.101/2005 e
                                    Assembleia Geral de Credores prevista nos artigos 35 a 46 da LFR
                                    <br />
                                    <br />
                                </li>
                            </ul>

                            <p class="text-lg-justify text-h6 font-weight-regular">
                                Nos termos do artigo 104 da Lei 11.101/2005 é obrigação da
                                Administração Judicial nos casos de Falência, colher dos sócios da
                                empresa Falida, dentre outros, a assinatura de Termo de
                                Comparecimento, com a indicação do
                                <strong>nome</strong> , da <strong>nacionalidade</strong> , do
                                <strong>estado civil</strong> e do
                                <strong>endereço completo</strong> de seus domicílios. A
                                <strong>PBB</strong> no exercício do encargo de Administradora
                                Judicial/Auxiliar do Juízo realiza a referida audiência de forma
                                virtual por meio de vídeo conferencia utilizando-se o aplicativo
                                ZOOM MEETING, ficando a gravação à disposição do juízo, caso
                                solicitada. O ato é reduzido a termo por meio de Ata e anexada ao
                                respectivo processo falimentar, sendo os dados pessoais utilizados
                                para o
                                <strong>
                                    <u> cumprimento do dever legal da AJ. </u>
                                </strong>
                                <br />
                                <br />
                                Em processos de Recuperação Judicial, a
                                <strong>PBB</strong> também em cumprimento ao múnus que lhe é
                                conferido e em observação à LFR, sugere data e horário para
                                realização de Assembleia Geral de Credores, (“AGC”) sempre que
                                ocorre a hipótese de objeção ao Plano Recuperacional conforme
                                previsto no art. 56 da Lei 11.101/2005, de modo a viabilizar a
                                votação do Plano pelos credores da sociedade(s) Recuperanda(s).
                                <br />
                                <br />
                                Nos casos de Assembleia Geral de Credores, o formato virtual é ao
                                vivo, realizado por meio da plataforma
                                <i>online</i> do <i>Youtube</i> , ficando disponível o acesso para
                                qualquer interessado. No prazo de 24 horas anteriores a data de
                                realização da AGC, os credores que desejam se fazerem representados
                                por procuradores constituídos devem enviar para o e-mail
                                <a
                                    href="mailto:agc@pbbadvogados.com.br"
                                    class="secondary--text font-weight-bold"
                                    >agc@pbbadvogados.com.br</a
                                >
                                documento hábil que comprove seus poderes ou a indicação das folhas
                                dos autos do processo em que se encontre o documento.
                                <br />
                                <br />
                                Nas AGCs a
                                <strong>PBB</strong> conta com o auxílio dos serviços de automação
                                fornecidos por empresa contratada pela Recuperanda.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Como é realizada a coleta dos Dados Pessoais
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A coleta dos dados discriminados em
                                <strong>2.1.</strong> e <strong> 2.1.1.</strong>, é realizada de
                                forma <i>online</i> e/ou física, conforme exposto nos itens
                                antecedentes deste Aviso.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Finalidade
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A finalidade da coleta dos dados pessoais destacados no item
                                <strong>2.1.</strong> e <strong> 2.1.1.</strong>, é necessária para
                                que a <strong>PBB</strong> cumpra o dever legal que lhe é imposto
                                por meio da Lei 11.101/2005, além de conferir as partes e
                                interessados, tratamento isonômico e transparente.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Do Tratamento dos Dados
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                Todos os dados pessoais, sensíveis ou não, são tratados com extrema
                                observação ao disposto na LGPD e demais normas correlatas e
                                setoriais. Os documentos digitais, virtuais ou digitalizados, assim
                                como as gravações realizadas, são arquivados em <u>nuvem</u> para
                                eventual utilização em Juízo. Em alguns casos, há possibilidade da
                                <strong>PBB</strong> , na condição de Administradora Judicial,
                                contratar, sob autorização do Juízo, pessoa natural ou pessoa
                                jurídica para realizar o arquivo físico de documentações da parte
                                insolvente, Recuperanda e/ou Falida que possam conter dados pessoais
                                e dados sensíveis.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Base Legal do Tratamento dos Dados
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                O tratamento dos dados pela <strong>PBB</strong> é realizado nos
                                termos do artigo 7º, II e VI, artigo 11, II, “a” e “d” da LGPD,
                                observada ainda, a Legislação Especial Lei 11.101/2005, 14.112/2020,
                                Decreto-Lei 7661/1945,e, ainda, outras normas setoriais aplicáveis a
                                depender da atuação da <strong>PBB</strong>.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Da recusa do Fornecimento Dos Dados Pessoais
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                O titular dos dados, especialmente os Credores e/ou terceiros
                                interessados, podem se recusar a fornecer os dados pessoais
                                eventualmente solicitados, por meio dos canais de acesso descritos
                                neste Aviso se assim o desejar, entretanto, em razão dos dados
                                viabilizarem o contato com a
                                <strong>PBB</strong>, eventual análise de crédito que o titular
                                possa ter em face de alguma empresa Recuperanda e/ou Falida, ou
                                ainda, para fins do exercício do direito de votação em Assembleias
                                Geral de Credores ou para fins do cumprimento da obrigação legal
                                imposta no art. 104 da LFR, sem eles
                                <strong> <u>não será possível</u> </strong> que a
                                <strong>PBB</strong> responda solicitações do titular, constate o
                                suposto crédito alegado para inserção na Relação de Credores e
                                posterior Quadro Geral de Credores do respectivo processo de
                                insolvência, ou aufira regularidade da representação do credor para
                                fins de cômputo do voto em AGC, dentre outras hipóteses. Além disso,
                                a ausência do fornecimento de determinados dados/informações pode
                                acarretar ao titular sanções civis e penais a depender do caso
                                concreto. a teor do disposto na LFR.
                                <br />
                                <br />
                                Isso porque em se tratado de pessoas naturais,
                                <u>sócias</u> de empresas em Recuperação Judicial ou Falidas, a Lei
                                11.101/2005, estabelece uma série de obrigações a estes titulares de
                                dados, dos quais
                                <strong>não poderão se recusar a fornecê-los.</strong>
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Da Política de Segurança e Boas Práticas
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A <strong>PBB</strong> trata os dados pessoais coletados com extrema
                                responsabilidade e segurança, adotando medidas técnicas e
                                administrativas aptas a proteger os dados pessoais de acessos não
                                autorizados e de situações acidentais ou ilícitas de destruição,
                                perda, alteração, comunicação ou difusão, por meio de acesso
                                restrito, utilização de senhas, programas de segurança com alta
                                tecnologia para a guarda e arquivamento dos dados tratados, no
                                intuito de mitigar os riscos aos titulares.
                                <br />
                                <br />
                                A resposta aos e-mails destinada aos titulares dos dados, realizada
                                pela
                                <strong>PBB</strong>, possui acesso limitado com <i>login</i> e
                                senha para acesso exclusivo da <strong>PBB</strong>, seus
                                funcionários, colaboradores e parceiros.
                                <br />
                                <br />
                                Além disso, a <strong>PBB</strong> adota políticas de boas práticas
                                e governança, internamente e externamente, com seus
                                <u>parceiros</u> , estes últimos, de igual modo nomeados pelo
                                respectivo Juízo, com o treinamento, capacitação e conscientização
                                de seus funcionários e colaboradores na realização do tratamento de
                                dados pessoais, sendo vedada a divulgação, venda, reprodução, cópia
                                e/ou qualquer outra forma de utilização das informações pessoais,
                                confidenciais e sigilosas compartilhadas e/ou de acesso facilitado,
                                coletadas para o cumprimento de dever legal que o encargo lhe
                                confere.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Do prazo de tratamento dos Dados
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A <strong>PBB</strong> leva muito a sério o direito à privacidade
                                dos titulares dos dados e nunca solicita dados que não sejam
                                necessários a finalidade destinada, observando sempre as hipóteses
                                previstas na LGPD, especialmente as constantes nos artigos 7º e 11º
                                da Lei, além das normas especiais e setoriais pertinentes. A
                                manutenção dos dados pessoais pela <strong>PBB</strong> na nuvem,
                                sistemas e/ou eventual arquivo físico, perdurará pelo período
                                necessário para atingir as finalidades expostas neste Aviso e/oupara
                                o cumprimento de obrigações legais e/ou assessórias oriundas dos
                                respectivos processos de insolvência, Recuperação Judicial e
                                Falência e/ou, ações judiciais a eles conexas ou assessórias.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Dos Direitos dos Titulares
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                É assegurada aos titulares dos dados, os direitos fundamentais de
                                liberdade, de intimidade e de privacidade, nos termos da Lei
                                13.709/2018.
                                <br />
                                <br />
                                O titular dos dados pessoais tem direito de obter da
                                <strong>PBB</strong>, em relação aos dados por ela tratados, a
                                qualquer momento e mediante requisição
                                <strong>exclusivamente</strong> por meio do e-mail
                                contato@pbbadvogados.com.bras questões dispostas no artigo 18 da
                                LGPD quando possível e/ou aplicável.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Do Compartilhamento de Dados
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A <strong>PBB</strong> realiza o compartilhamento dos dados pessoais
                                tratados com seus
                                <u
                                    >colaboradores, funcionários, parceiros e, eventualmente com
                                    empresas/pessoas contratadas para arquivo de documentos</u
                                >
                                , tudo estritamente para o cumprimento do exercício do encargo e
                                obrigações legais.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Transferências Internacionais de Dados
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                Os dados pessoais coletados pela
                                <strong>PBB</strong> são protegidos no Brasil e não há transferência
                                Internacional dos dados tratados fora do território Nacional,
                                <strong>salvo</strong> se houver situação excepcional que,
                                juridicamente impute a <strong>PBB</strong> o dever de tal
                                compartilhamento.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Do Encarregado pelo Tratamento de Dados Pessoais
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                A <strong>PBB</strong> possui como Encarregado de Dados, também
                                conhecido como DPO – <i>Data Protection Officer</i> , o
                                <strong> Dr. Otávio De Paoli Balbino</strong>, inscrito na
                                <strong>OAB/MG 123.643</strong> , representante legal da
                                <strong>PBB</strong>, o qual exerce todas as atividades descritas no
                                § 2º, do art. 41 da Lei 13.709/2018, por meio do e-mail:
                                contato@pbbadvogados.com.br e telefone (31) 3656-1514. As atividades
                                do Encarregado, dentre outras e ressalvadas as hipóteses da
                                Autoridade Nacional – ANPD em estabelecer normas complementares
                                sobre a definição e as atribuições do encarregado, inclusive
                                hipóteses de dispensa da necessidade de sua indicação, conforme a
                                natureza e o porte da entidade ou o volume de operações de
                                tratamento de dados, consistem em:
                            </p>

                            <ol class="text-lg-justify text-h6 font-weight-regular px-lg-10">
                                <li>
                                    <strong>aceitar</strong> reclamações e comunicações dos
                                    titulares, prestar esclarecimentos e adotar providências;
                                </li>
                                <li>
                                    <strong>receber</strong> comunicações da Autoridade Nacional e
                                    adotar providências;
                                </li>
                                <li>
                                    <strong>orientar</strong> os funcionários e os contratados da
                                    entidade a respeito das práticas a serem tomadas em relação à
                                    proteção de dados pessoais; e
                                </li>
                                <li>
                                    <strong>executar</strong> as demais atribuições determinadas
                                    pelo controlador ou estabelecidas em normas complementares.
                                </li>
                            </ol>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Da eliminação dos Dados Pessoais
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                Após encerrada a finalidade exposta neste Aviso, e observado o
                                disposto na Lei Especial nº 11.101/2005, 14.112/2020 e Decreto-Lei
                                7661/1945, bem como no Código Civil, no que se refere aos prazos
                                prescricionais, especialmente o disposto no art. 205 ou ainda,
                                outras legislações setoriais específicas que devem ser observadas
                                pela
                                <strong>PBB</strong> no exercício de sua função como Administradora
                                Judicial e/ou Auxiliar do Juízo, se compromete a
                                <strong>eliminar</strong> a cópia dos dados coletados do titular
                                virtualmente armazenados, além da cópia daqueles armazenados na
                                forma física.
                                <br />
                                <br />
                                Quanto aos documentos eventualmente arrecadados decorrentes do
                                exercício do encargo da
                                <strong>PBB</strong>, em cumprimento a dever legal, fica consignado
                                a entrega ao possuidor quando finda a finalidade da utilização da
                                documentação pela <strong>PBB</strong>.
                                <br />
                                <br />
                                Portanto, finda a necessidade dos documentos que contenham dados
                                pessoais e/ou dados pessoais sensíveis a
                                <strong>PBB excluirá</strong> de seus sistemas virtuais e/ou
                                físicos, e/ou devolverá a documentação ao responsável legal e/ou
                                titular.
                            </p>
                        </div>
                    </v-row>

                    <v-row class="mb-10 px-2">
                        <h2 class="text-h6 text-lg-h5 font-weight-black primary--text mb-5">
                            Da Possibilidade de Alteração do Aviso De Privacidade
                        </h2>
                        <div>
                            <p class="text-lg-justify text-h6 font-weight-regular">
                                Caso haja qualquer alteração relevante na forma da qual os dados
                                pessoais são coletados ou processados, serão fornecidos pela
                                <strong>PBB</strong>, “Avisos Adicionais” ou “Aditivo” ao presente
                                “Aviso de Privacidade”, com as informações necessárias para o
                                conhecimento do titular, em prol da transparência no tratamento de
                                seus dados, conforme mencionado anteriormente no presente
                                Instrumento.
                                <br />
                                <br />
                                A alteração no Aviso ficará de igual modo, disponível no site da
                                <strong>PBB</strong>,
                                <a
                                    target="_blank"
                                    class="secondary--text font-weight-black"
                                    href="https://pbbadvogados.com.br/"
                                    >www.pbbadvogados.com.br</a
                                >
                                onde o titular poderá cientificar-se das eventuais mudanças.
                                <br />
                                <br />
                                O titular deve sempre se certificar em ler atentamente tanto o Aviso
                                de Privacidade, como suas eventuais alterações e, em caso de
                                dúvidas, entrar em contato direto com a
                                <strong>PBB</strong>,
                                <strong> <u>exclusivamente</u> </strong>
                                pelos canais de acesso indicados em
                                <strong>2.12</strong>.
                            </p>
                        </div>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
export default {
    name: 'PrivacyPolicePage'
};
</script>

<style lang="scss">
.barra-lateral {
    background-color: var(--v-secondary-base);
    height: 100%;
}
</style>
